export default {
  OVERLAY: 9999,
};
